import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { BehaviorSubject } from 'rxjs';
import DealTerm from 'src/app/interfaces/deal-term';
import Project from 'src/app/interfaces/project';
import {
  GET_DEAL_WITH_TERMS,
  INIT_DEAL_TERMS,
  SAVE_DEAL_TERMS,
  UpdateDealTermInput,
} from './graphql/deal-terms';
import Permission from 'src/app/interfaces/permission';
import { AlertService } from '../../alert/alert.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

const config = new MatSnackBarConfig();
config.panelClass = ['save-success'];
config.horizontalPosition = 'center';
config.verticalPosition = 'top';
config.duration = 3000;
@Injectable({
  providedIn: 'root',
})
export class DealTermsService {
  private _project: Project | null = null;
  private project = new BehaviorSubject<Project | null>(this._project);
  public project$ = this.project.asObservable();
  private _terms: DealTerm | null = null;
  private terms = new BehaviorSubject<DealTerm | null>(this._terms);
  public terms$ = this.terms.asObservable();
  private _permissions: Permission | null = null;
  private permissions = new BehaviorSubject<Permission | null>(
    this._permissions
  );
  public permissions$ = this.permissions.asObservable();
  constructor(
    public apollo: Apollo,
    private alert: AlertService,
    private _snackBar: MatSnackBar
  ) {}

  public getProjectWithTerms(id: string) {
    let sub = this.apollo
      .watchQuery({
        query: GET_DEAL_WITH_TERMS,
        variables: { id },
      })
      .valueChanges.subscribe(({ data, loading }) => {
        if(data){
          let { project, me } = data as {
            project: Project;
            me: { permissionsForResource: Permission | null };
          };
          this._project = project;
          this.project.next(this._project);
          this._permissions = me.permissionsForResource;
          this.permissions.next(this._permissions);

          if (this._project.dealTerm) {
            this._terms = this._project.dealTerm;
            this.terms.next(this._terms);
          } else if (!!me.permissionsForResource?._create) {
            this.initTerm(id);
          }
          sub?.unsubscribe();
        }
      });
  }
  public initTerm(project_id: string) {
    let sub = this.apollo
      .mutate({
        mutation: INIT_DEAL_TERMS,
        variables: {
          project_id,
        },
      })
      .subscribe(({ data, loading }) => {
        let { createDealTerm } = data as { createDealTerm: DealTerm | null };
        this._terms = createDealTerm;
        this.terms.next(this._terms);
        sub?.unsubscribe();
      });
  }
  public saveTerm(id: string, input: UpdateDealTermInput) {
    let sub = this.apollo
      .mutate({ mutation: SAVE_DEAL_TERMS, variables: { id, input } })
      .subscribe(({ data, loading }) => {
        let { updateDealTerm } = data as { updateDealTerm: DealTerm | null };
        this._terms = updateDealTerm;
        this._snackBar.open('Deal Terms Saved successfully', 'Ok', config);
        this.terms.next(this._terms);
      });
  }
}
